import React from "react";
import { AnimateType } from "@/types";

import "./index.css";

const cx = require("classnames");

const INIT_TIME = 600;
const DURATION_TIME = 200;

interface AnimateLineProps {
  children: React.ReactElement | React.ReactElement[];
  animateType: AnimateType;
  animateName?: string
}

const AnimateLines: React.FC<AnimateLineProps> = (props) => {
  const { children, animateType = 'none', animateName = 'animate_line_show' } = props;

  const [cls, setCls] = React.useState<string>();


  // 当离开页面时，暂停动画，从新进入页面之后，恢复动画
  React.useEffect(() => {
    if (animateType === 'fade_in') {
      setCls("animate_line_play");
    }
    
    if (animateType === 'fade_out') {
      setCls("animate_line_play animate_line_paused");
    }

    if (animateType === 'none') {
      setCls("animate_line_none");
    }
    
    
  }, [animateType]);

  // 复制子节点 每行文字动画添加动画延迟时间
  const renderAnimateLine = () => {
    return React.Children.map(children, (child, index) => {
      const ms = `${INIT_TIME + DURATION_TIME * index}ms`;
      return React.cloneElement(child, {
        style: { animationDelay: ms, ...child.props.style },
        className: cx(
          child.props.className,
          cls,
          'animate_line_item',
          {
            [animateName]: animateType === 'fade_in'
          },
        ),
      });
    });
  };

  return <>{renderAnimateLine()}</>;
};

export default AnimateLines;
